var _style, _polyline, _ellipse, _polyline2, _line, _polyline3, _line2, _g, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 982.5 199.5",
    style: {
      enableBackground: "new 0 0 982.5 199.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:10;stroke-miterlimit:10;}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_3_",
    className: "st0",
    points: "24.2,188.9 24.2,27.3 161.5,176.4 161.5,14.4 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_7_",
    className: "st0",
    cx: 267.8,
    cy: 101.6,
    rx: 80.9,
    ry: 82.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_10_",
    className: "st0",
    points: "623.5,19.1 503.9,19.1 503.9,184.1 623.5,184.1 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    className: "st0",
    x1: 530,
    y1: 132.5,
    x2: 623.5,
    y2: 132.5
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_9_",
    className: "st0",
    points: "642,14.4 642,184.1 761,184.1 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_13_",
    className: "st0",
    x1: 777.5,
    y1: 14.4,
    x2: 777.5,
    y2: 188.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M370.5,188.9V19.1h42.8c22.2,0,43.1,11.5,54.2,30.7c4.4,7.7,7.5,16.9,7.5,27.7 c0,14.9-5.8,26-13.1,34.1c-10.8,12-26.3,18.6-42.5,18.6h-15.8l64.8,55.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    points: "471.7,181.6 480.7,189.2 465.3,189.2  "
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_14_",
    className: "st0",
    cx: 878.8,
    cy: 101.6,
    rx: 80.9,
    ry: 82.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78831e8793f00cd4e6123b9f71672e03.svg";
export { ForwardRef as ReactComponent };